import { useIsVivaEngageRebranding } from '@ms/yammer-hooks/dist/rebranding';

import { faviconPath, vivaEngageFaviconPath } from './favicons';

type UseGetFaviconPath = () => string;
export const useGetFaviconPath: UseGetFaviconPath = () => {
  const isVivaEngageRebranding = useIsVivaEngageRebranding();

  return isVivaEngageRebranding ? vivaEngageFaviconPath : faviconPath;
};
